import { render, staticRenderFns } from "./Coral.vue?vue&type=template&id=5ef940c0&scoped=true&"
import script from "./Coral.vue?vue&type=script&lang=js&"
export * from "./Coral.vue?vue&type=script&lang=js&"
import style0 from "./Coral.vue?vue&type=style&index=0&id=5ef940c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef940c0",
  null
  
)

export default component.exports